module.exports = __webpack_public_path__ + "static/media/help-centre.e94cd74e.png";